module.exports = __webpack_public_path__ + "img/logo-mdh-mn-h-blu_rgb.30c03f31.png";